export default [
    {
        path: 'programassociais',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'ProgramaSocialController' }
    },
    {
        path: 'programassociais/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'ProgramaSocialController' },
    },
    {
        path: 'programassociais/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'ProgramaSocialController'
        }
    },
    {
        path: 'programassociais/beneficiarios/:id',
        component: require('./programafamilia/Read').default,
        meta: { middleware: 'auth', controller: 'ProgramaSocialFamiliaController' }
    },
    {
        path: 'programassociais/concessao/:id/edit',
        component: require('./programafamilia/Edit').default,
        meta: { middleware: 'auth', controller: 'ProgramaSocialFamiliaController' }
    },
    {
        path: 'programassociais/concessao/:id/show',
        component: require('./programafamilia/Show').default,
        meta: { middleware: 'auth', controller: 'ProgramaSocialFamiliaController' }
    },

    {
        path: 'relatorios/programassociais',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/programassociais/home',
        meta: { middleware: 'auth', controller: 'RelatorioProgramaSocialController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_programas',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioProgramaSocialController' },
        }, {
            path: 'graficos',
            name: 'graficos_programas',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioProgramaSocialController' },
        }
        ]
    }
];

